<template>
  <div
    :class="[classes.message, message.styleClass]"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    :data-p="dataP"
    @click="onMessageClick"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <component
      :is="templates.container"
      v-if="templates.container"
      :message="message"
      :closeCallback="onCloseClick"
    />
    <div
      v-else
      :class="[classes.messageContent, message.contentStyleClass]"
    >
      <template v-if="!templates.message">
        <component
          :is="iconComponent || 'span'"
          v-if="!message?.mini && message?.messageIcon"
          :class="classes.messageIcon"
        />
        <div
          :class="classes.messageText"
          :data-p="dataP"
        >
          <span
            :class="classes.hed"
            :data-p="dataP"
          >
            {{ message.hed }}
          </span>
          <div
            v-if="message.detail"
            :class="classes.detail"
            :data-p="dataP"
          >
            {{ message.detail }}
          </div>
        </div>
      </template>
      <component :is="templates.message" v-else :message="message"></component>
      <div v-if="!message?.mini && message?.closeIcon">
        <button
          :aria-label="closeAriaLabel"
          autofocus
          :class="classes.closeButton"
          :data-p="dataP"
          type="button"
          @click="onCloseClick"
        >
          <component :is="(message?.closeIcon && 'CloseIcon') || 'span'" :class="[classes.closeIcon, closeIconClass]" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { cn } from '../../utils/classnames/cn.js';

import CloseIcon from '../icons/trash/trash.vue';
import InfoIcon from '../icons/trash/trash.vue';
import SuccessIcon from '../icons/trash/trash.vue';
import DangerIcon from'../icons/trash/trash.vue';
import WarningIcon from '../icons/trash/trash.vue';

// TODO: extract props and options to it's own file.
const validVariants = [
  'danger',
  'danger-soft',
  'info',
  'info-soft',
  'secondary',
  'success',
  'success-soft',
  'warning',
  'warning-soft',
];

export default {
  name: 'ToastMessage',
  components: {
    CloseIcon,
    DangerIcon,
    InfoIcon,
    SuccessIcon,
    WarningIcon,
  },
  hostName: 'Toast',
  props: {
    closeIcon:        { type: Boolean,  default: false },
    message:          { type: null,     default: null },
    messageIcon:      { type: Boolean,  default: false },
    templates:        { type: Object,   default: null },
    //variant:          { type: String,   default: 'info-soft', validator: (x) => validVariants.includes(x) },
  },
  emits: ['close'],
  closeTimeout: null,
  createdAt: null,
  lifeRemaining: null,
  computed: {
    classes () {
      return {
        message: [
          'ui-toast-message',
          `ui-toast-message--${this.message?.variant || 'info-soft'}`,
          { 'ui-toast-message--mini': this.message?.mini },
        ],
        messageContent: 'ui-toast-message-content',
        messageIcon: ['ui-toast-message-icon'],
        messageText: 'ui-toast-message-text',
        hed: 'ui-toast-hed',
        detail: 'ui-toast-detail',
        closeButton: 'ui-toast-close-button',
        closeIcon: ['ui-toast-close-icon' ],
      };
    },
    iconComponent() {
      return {
        info:           this.message?.messageIcon && InfoIcon,
        'info-soft':    this.message?.messageIcon && InfoIcon,
        danger:         this.message?.messageIcon && DangerIcon,
        'danger-soft':  this.message?.messageIcon && DangerIcon,
        success:        this.message?.messageIcon && SuccessIcon,
        'success-soft': this.message?.messageIcon && SuccessIcon,
        warning:        this.message?.messageIcon && WarningIcon,
        'warning-soft': this.message?.messageIcon && WarningIcon,
      }[this.message.variant];
    },
    closeAriaLabel() {
      return this.$ui?.locale?.aria ? this.$ui?.locale?.aria.close : undefined;
    },
    dataP() {
      return cn({
        [this.message.variant]: this.message.variant
      });
    }
  },
  mounted() {
    if (this.message.life) {
      this.lifeRemaining = this.message.life;
      this.startTimeout();
    }
  },
  beforeUnmount() {
    this.clearCloseTimeout();
  },
  methods: {
    startTimeout() {
      this.createdAt = new Date().valueOf();
      this.closeTimeout = setTimeout(() => {
        this.close({ message: this.message, type: 'life-end' });
      }, this.lifeRemaining);
    },
    close(params) {
      this.$emit('close', params);
    },
    onCloseClick() {
      this.clearCloseTimeout();
      this.close({ message: this.message, type: 'close' });
    },
    clearCloseTimeout() {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
    },
    onMessageClick(event) {
      this.props?.onClick && this.props.onClick({ originalEvent: event, message: this.message });
    },
    onMouseEnter(event) {
      if (this.props?.onMouseEnter) {
        this.props.onMouseEnter({ originalEvent: event, message: this.message });

        if (event.defaultPrevented) {
          return;
        }

        if (this.message.life) {
          this.lifeRemaining = this.createdAt + this.lifeRemaining - Date().valueOf();
          this.createdAt = null;
          this.clearCloseTimeout();
        }
      }
    },
    onMouseLeave(event) {
      if (this.props?.onMouseLeave) {
        this.props.onMouseLeave({ originalEvent: event, message: this.message });

        if (event.defaultPrevented) {
          return;
        }

        if (this.message.life) {
          this.startTimeout();
        }
      }
    }
  },
};
</script>
